import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO_DATA = {
  '/': {
    title: 'Destilerija Kovačić | Kraft Džin iz Srbije',
    description: 'Premium kraft džinovi ručno rađeni u Mokrinu. ORIGIN Classic, Citrus i UV džin. Besplatna dostava za Beograd i Novi Sad. Naručite online!',
    keywords: 'kraft džin, craft gin, srpski džin, destilerija Kovačić, Mokrin, premium džin'
  },
  '/shop': {
    title: 'Prodavnica | Kraft Džin Online - Destilerija Kovačić',
    description: 'Kupite premium kraft džin online. ORIGIN Classic (4.200 RSD), Citrus (4.400 RSD), UV (4.600 RSD). Brza dostava širom Srbije.',
    keywords: 'kupi džin online, džin cena, kraft džin prodaja, gin Srbija, ORIGIN džin kupovina'
  },
  '/about': {
    title: 'O Nama | Destilerija Kovačić - Priča o Kraft Džinu',
    description: 'Upoznajte Destileriju Kovačić iz Mokrina. Naša strast za craft spirits i tradicija proizvodnje premium džinova. Saznajte više o nama.',
    keywords: 'destilerija Kovačić priča, kraft džin proizvodnja, Mokrin destilerija, srpski craft spirits'
  },
  '/contact': {
    title: 'Kontakt | Destilerija Kovačić',
    description: 'Kontaktirajte Destileriju Kovačić. Telefon: +381 60 463 1241, Email: destilerijakovacic@gmail.com. Mokrin, Srbija.',
    keywords: 'destilerija Kovačić kontakt, džin Mokrin, kontakt telefon'
  },
  '/rent-gin-bar': {
    title: 'Rent a Gin Bar | Iznajmite Džin Bar za Vaš Event',
    description: 'Iznajmite naš mobilni džin bar za venčanja, proslave i korporativne evente. Profesionalna usluga sa premium kraft džinovima.',
    keywords: 'rent gin bar, džin bar za venčanje, mobilni bar, kokteli za event, džin katering'
  },
  '/checkout': {
    title: 'Završi Kupovinu | Destilerija Kovačić',
    description: 'Završite Vašu porudžbinu kraft džina. Sigurna kupovina, brza dostava širom Srbije.',
    keywords: 'džin narudžbina, checkout, kupovina džina'
  }
};

export default function SEOHead() {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    const seo = SEO_DATA[path] || SEO_DATA['/'];
    
    // Update title
    document.title = seo.title;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', seo.description);
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', seo.keywords);
    }
    
    // Update OG tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', seo.title);
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', seo.description);
    }
    
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', `https://destilerijakovacic.com${path}`);
    }
    
    // Update Twitter tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', seo.title);
    }
    
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', seo.description);
    }
    
    // Update canonical
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `https://destilerijakovacic.com${path === '/' ? '' : path}`);
    }
    
  }, [location]);
  
  return null;
}
